export enum StageType {
  CUP = 2,
  OPEN = 3,
  LEAGUE_WITH_PENALTIES = 4,
}
